// src/theme.js

const themeConfig = {
  palette: {
    // Force light mode
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    // Override default background
    background: {
      default: '#ffffff', // the page background
      paper: '#ffffff',   // surfaces (Cards, Paper, etc.)
    },
  },
  typography: {
    fontFamily: 'Oswald, sans-serif',
  },
};

export default themeConfig;
